import React, { useState, useRef } from "react";
import styles from "../styles/InputCustom.module.scss";
import Swal from "sweetalert2";
import { CalendarTodayOutlined } from "@material-ui/icons";

export default function InputCustom({
  name = "",
  value = "",
  onChange = () => {},
  onBlur = () => {},
  onClick = () => {},
  label = "",
  placeholder = null,
  forceTouched = false,
  touched,
  errors,
  maxLength = 255,
  type = "text",
  icon_left = null,
  icon_right = null,
  type_input_datatable = null,
  required = false,
  disabled = false,
  readOnly = false,
  link = null,
  style = {},
  onKeyDown = () => {},
  onFocus = () => {},
  icon_style = {},
  onIconClick = null,
  helperText = null,
  helperTextStyle = {},
  inputMode = null,
  tooltip_custom = undefined,
  tooltip_text = "Mais informações",
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [tooltip_visivel, setTooltipVisivel] = useState(false);
  const inputRef = useRef(null);

  const handleFocus = (e) => {
    setIsFocused(true);
    onFocus(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    onBlur(e);
  };

  const handleChangeTime = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
    let formatted = raw;

    if (raw.length > 2) {
      formatted = raw.slice(0, 2) + ":" + raw.slice(2);
    }

    onChange({ ...e, target: { ...e.target, value: formatted, name } });
  };

  const eh_campo_temporal = type === "date" || type === "time";
  const isFloating = isFocused || Boolean(value) || eh_campo_temporal;
  const isBordaAtiva = isFocused || Boolean(value);
  const hasError = (touched?.[name] || forceTouched) && errors?.[name];

  const icone_efetivo = type === "date" ? <CalendarTodayOutlined style={{ fontSize: 20 }} /> : icon_left;
  const icone_click_efetivo = type === "date" ? () => inputRef.current?.showPicker?.() : onIconClick;

  return (
    <div
      className={styles.container}
      style={
        type_input_datatable
          ? { width: "auto", flex: "none", ...style }
          : style || null
      }
    >
      {type === "color" ? (
        <>
          {label && (
            <label className={`${styles.label} ${hasError ? styles.labelError : ""}`}>
              {label} {required && <span className={styles.requiredStar}>*</span>}
            </label>
          )}
          <div className={styles.inputColor}>
            <input
              name={name}
              type={type}
              value={value}
              onChange={onChange}
              onBlur={handleBlur}
              disabled={disabled}
              readOnly={readOnly}
              onKeyDown={onKeyDown}
              onFocus={handleFocus}
              inputMode={inputMode}
            />

            <p>{value}</p>
          </div>
        </>
      ) : (
        <>
          {link && (
            <div className={styles.containerLink}>
              {label && (
                <label
                  className={`${styles.floatingLabel} ${isFloating ? styles.floating : ""} ${hasError ? styles.labelError : ""}`}
                >
                  {label} {required && <span className={styles.requiredStar}>*</span>}
                </label>
              )}
              <input
                maxLength={maxLength}
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                onBlur={handleBlur}
                onClick={onClick}
                className={`${styles.input} ${isBordaAtiva ? styles.focused : ""} ${hasError ? styles.hasError : ""}`}
                style={
                  icon_left
                    ? { paddingRight: "40px" }
                    : icon_right
                    ? { paddingLeft: "40px" }
                    : null
                }
                placeholder={placeholder ?? ""}
                disabled={disabled}
                readOnly={readOnly}
                onKeyDown={onKeyDown}
                onFocus={handleFocus}
              />

              <button
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(link);

                  Swal.fire(
                    "Copiado!",
                    "Link copiado para a área de transferência.",
                    "success",
                  );
                }}
              >
              </button>
            </div>
          )}

          {!type_input_datatable && !link && (
            <div className={styles.inputWrapper}>
              {label && (
                <label
                  className={`${styles.floatingLabel} ${isFloating ? styles.floating : ""} ${hasError ? styles.labelError : ""}`}
                >
                  {label} {required && <span className={styles.requiredStar}>*</span>}
                </label>
              )}

              {Boolean(icon_right) && (
                <span style={icon_style} className={styles.iconRight}>
                  {icon_right}
                </span>
              )}

              <input
                ref={inputRef}
                maxLength={type === "time" ? 5 : maxLength}
                name={name}
                type={type === "time" ? "text" : type}
                value={value}
                onChange={type === "time" ? handleChangeTime : onChange}
                onBlur={handleBlur}
                onClick={onClick}
                className={`${styles.input} ${isBordaAtiva ? styles.focused : ""} ${hasError ? styles.hasError : ""}`}
                style={{
                  ...(icone_efetivo ? { paddingRight: "40px" } : icon_right ? { paddingLeft: "40px" } : {}),
                  ...(!label ? { paddingTop: "16px", paddingBottom: "16px" } : {}),
                }}
                placeholder={type === "time" ? "00:00" : (placeholder ?? "")}
                disabled={disabled}
                readOnly={readOnly}
                onKeyDown={onKeyDown}
                onFocus={handleFocus}
                inputMode={type === "time" ? "numeric" : inputMode}
              />

              {Boolean(icone_efetivo) && (
                <span
                  style={icon_style}
                  className={`${styles.iconLeft} ${type === "date" ? styles.iconeData : ""}`}
                  onClick={icone_click_efetivo}
                  onMouseEnter={tooltip_custom !== undefined ? () => setTooltipVisivel(true) : undefined}
                  onMouseLeave={tooltip_custom !== undefined ? () => setTooltipVisivel(false) : undefined}
                >
                  {icone_efetivo}
                </span>
              )}

              {tooltip_visivel && (
                <div className={styles.tooltip}>
                  {tooltip_custom ?? (
                    <p className={styles.tooltipTexto}>{tooltip_text}</p>
                  )}
                </div>
              )}
            </div>
          )}

          {type_input_datatable && !link && (
            <div className={styles.inputWrapper}>
              {label && (
                <label
                  className={`${styles.floatingLabel} ${
                    type_input_datatable === "small"
                      ? styles.floatingLabelSmall
                      : ""
                  } ${isFloating ? styles.floating : ""} ${hasError ? styles.labelError : ""}`}
                >
                  {label} {required && <span className={styles.requiredStar}>*</span>}
                </label>
              )}

              {Boolean(icon_right) && (
                <span
                  style={icon_style}
                  className={
                    type_input_datatable === "small"
                      ? styles.iconRightDatatableSmall
                      : styles.iconRightDatatable
                  }
                >
                  {icon_right}
                </span>
              )}

              <input
                maxLength={maxLength}
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                onBlur={handleBlur}
                onClick={onClick}
                className={`${styles.inputDatatable} ${
                  type_input_datatable === "small"
                    ? styles.inputDatatableSmall
                    : ""
                } ${isBordaAtiva ? styles.focused : ""} ${hasError ? styles.hasError : ""}`}
                style={
                  icon_left
                    ? { paddingRight: "40px" }
                    : icon_right
                    ? { paddingLeft: "40px" }
                    : null
                }
                placeholder={placeholder ?? ""}
                disabled={disabled}
                readOnly={readOnly}
                onKeyDown={onKeyDown}
                onFocus={handleFocus}
                inputMode={inputMode}
              />

              {Boolean(icon_left) && (
                <span
                  style={icon_style}
                  className={
                    type_input_datatable === "small"
                      ? styles.iconLeftDatatableSmall
                      : styles.iconLeftDatatable
                  }
                  onClick={onIconClick}
                >
                  {icon_left}
                </span>
              )}
            </div>
          )}
        </>
      )}

      {helperText && (
        <p className={styles.helperText} style={helperTextStyle}>
          {helperText}
        </p>
      )}

      {hasError && (
        <p className={styles.errorMessage}>
          {errors?.[name]}
        </p>
      )}
    </div>
  );
}
